import { render } from "./BusZuliZhiJianInfo.vue?vue&type=template&id=192f364c&scoped=true"
import script from "./BusZuliZhiJianInfo.vue?vue&type=script&lang=js"
export * from "./BusZuliZhiJianInfo.vue?vue&type=script&lang=js"

import "./BusZuliZhiJianInfo.vue?vue&type=style&index=0&id=192f364c&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192f364c"]])

export default __exports__